import { render, staticRenderFns } from "./PopupAlert.vue?vue&type=template&id=43151e1c"
import script from "./PopupAlert.vue?vue&type=script&lang=js"
export * from "./PopupAlert.vue?vue&type=script&lang=js"
import style0 from "./PopupAlert.vue?vue&type=style&index=0&id=43151e1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports